import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import { assetsPath } from "../../../../../utils";

export default ({ currentLang, handleClick }) => {
  const shouldDisplayByLang = (selectLang) => {
    return currentLang === selectLang ? "display" : "display-none";
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // viewBox="0 0 258.4 258.4"
      className="allfloor-of-unitplan"
    >
      <g id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <image
            xlinkHref={`${assetsPath("phuket-skypark")}/images/siteplan/cn.png`}
            height="100%"
            width="100%"
          />
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <image
            xlinkHref={`${assetsPath("phuket-skypark")}/images/siteplan/ru.png`}
            height="100%"
            width="100%"
          />
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <image
            xlinkHref={`${assetsPath("phuket-skypark")}/images/siteplan/en.png`}
            height="100%"
            width="100%"
          />
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/a/siteplan.js